
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('HOME_MEDIAS_TOPVIDEOS').plugin(axiosPlugin, {template: "array"});

let fetchHomeMediasTopVideosAction = redux.fetchActionGet();

export const fetchHomeMediasTopVideos = () => fetchHomeMediasTopVideosAction(`/features/medias-videos`);

export const homeMediaTopVideos = redux.reducer();